document.addEventListener("DOMContentLoaded", function () {
  const sliderContainer = document.querySelector(".slider-container");
  const dots = document.querySelectorAll(".image-banner-dot");
  let currentSlide = 0;
  const totalSlides = dots.length;
  let slideInterval;

  // Function to change the slide
  function changeSlide(slideIndex) {
    // Adjust for overflow
    if (slideIndex < 0) {
      currentSlide = totalSlides - 1;
    } else if (slideIndex >= totalSlides) {
      currentSlide = 0;
    } else {
      currentSlide = slideIndex;
    }

    // Update slider container position
    sliderContainer.style.transform = `translateX(-${currentSlide * 100}%)`;

    // Update dot styles
    dots.forEach((dot, index) => {
      dot.classList.remove("active");
      if (index === currentSlide) {
        dot.classList.add("active");
      }
    });
  }

  // Add event listeners to dots
  dots.forEach((dot, index) => {
    dot.addEventListener("click", function () {
      changeSlide(index);
    });
  });

  // Initialize with the first slide and set the initial interval
  changeSlide(currentSlide);
});
